import { useMemo, useState } from "react";
import {
  List,
  TextField,
  WrapperField,
  DatagridConfigurable,
  WithRecord,
  DateField,
  BulkDeleteWithConfirmButton,
  useTheme,
  NumberField,
  BooleanField,
} from "react-admin";
import PromotionAddDialog from "../../components/promotions/create/PromotionAddDialog";
import PromotionEditDialog from "../../components/promotions/edit/PromotionEditDialog";
import promotionFilterList from "../../components/promotions/filter/promotionFilterList";
import EditBtn from "../../components/editBtn/EditBtn";
import CreateOnlyAction from "../../components/tableListActions/CreateOnlyAction";

const PromotionList = () => {
  const [openAdd, setOpenAdd] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [recordId, setRecordId] = useState();
  const [theme] = useTheme("light");

  const handleClickOpenAdd = () => {
    setOpenAdd(true);
  };
  const handleClickOpenEdit = (recId) => () => {
    setRecordId(recId);
    setOpenEdit(true);
  };
  const list = useMemo(
    () => (
      <List
        empty={false}
        actions={<CreateOnlyAction createHandler={handleClickOpenAdd} />}
        filters={promotionFilterList}
        queryOptions={{ meta: { sort: ["created_at ASC"] } }} // overide default sort
      >
        <DatagridConfigurable
          bulkActionButtons={<BulkDeleteWithConfirmButton />}
          sx={{
            "& .RaDatagrid-expandedPanel > td": {
              p: 0,
              bgcolor: theme !== "dark" ? "#E7EBF0" : "grey.800",
            },
          }}
        >
          <TextField source="name" />
          <DateField
            source="start_date"
            options={{
              year: "numeric",
              month: "short",
              day: "2-digit",
            }}
          />
          <DateField
            source="end_date"
            options={{
              year: "numeric",
              month: "short",
              day: "2-digit",
            }}
          />
          <NumberField source="minimal" />
          <NumberField source="divider" />
          <BooleanField source="always_round_up" textAlign="center" />
          <WrapperField label="Actions" textAlign="center">
            <WithRecord
              label="author"
              render={(record) => {
                return <EditBtn editHandler={handleClickOpenEdit(record.id)} />;
              }}
            />
          </WrapperField>
        </DatagridConfigurable>
      </List>
    ),
    []
  );
  return (
    <>
      {list}
      <PromotionAddDialog open={openAdd} setOpen={setOpenAdd} />
      <PromotionEditDialog
        open={openEdit}
        setOpen={setOpenEdit}
        recordId={recordId}
      />
    </>
  );
};

export default PromotionList;
